import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instance1wzn9b23peown as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default3mq4ssp61rg7w as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance23401jnwmesxf as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().m4i("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.g4i_1 = null;
        this.h4i_1 = null;
        this.i4i_1 = 0n;
      }
      q2() {
        return this.i4i_1;
      }
      r3y() {
        return this;
      }
      s3y() {
        return this.q2() === 0n;
      }
      t3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().m4i("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      y3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      b3z() {
        var tmp0_elvis_lhs = this.g4i_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.u4i();
          return this.b3z();
        }
        var v = segment.v4i();
        this.i4i_1 = subtract(this.i4i_1, 1n);
        if (segmentSize === 1) {
          this.u4i();
        }
        return v;
      }
      w4i() {
        var tmp0_elvis_lhs = this.g4i_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.t3y(2n);
          if (segmentSize === 0) {
            this.u4i();
            return this.w4i();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.b3z() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.b3z() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.x4i();
        this.i4i_1 = subtract(this.i4i_1, 2n);
        if (segmentSize === 2) {
          this.u4i();
        }
        return v;
      }
      y4i() {
        return Unit_instance;
      }
      z4i(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.i4i_1 = add(out.i4i_1, remainingByteCount);
        var s = this.g4i_1;
        while (currentOffset >= fromInt(ensureNotNull(s).p4i_1 - s.o4i_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.p4i_1 - s.o4i_1 | 0));
          s = s.s4i_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).a4j();
          copy.o4i_1 = copy.o4i_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.o4i_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.p4i_1;
          tmp.p4i_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.g4i_1 == null) {
            out.g4i_1 = copy;
            out.h4i_1 = copy;
          } else if (false) {
            out.h4i_1 = ensureNotNull(out.h4i_1).b4j(copy).c4j();
            if (ensureNotNull(out.h4i_1).t4i_1 == null) {
              out.g4i_1 = out.h4i_1;
            }
          } else {
            out.h4i_1 = ensureNotNull(out.h4i_1).b4j(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.p4i_1 - copy.o4i_1 | 0));
          currentOffset = 0n;
          s = s.s4i_1;
        }
      }
      d4j() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.h4i_1);
        if (tail.p4i_1 < 8192 && tail.r4i_1) {
          result = subtract(result, fromInt(tail.p4i_1 - tail.o4i_1 | 0));
        }
        return result;
      }
      v3w(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.g4i_1).e4j(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.g4i_1 == null) {
            return ensureNotNull(null).e4j(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.h4i_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.p4i_1 - s.o4i_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.t4i_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).e4j(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.g4i_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.p4i_1 - s_0.o4i_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.s4i_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).e4j(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      y4() {
        return this.i3v(this.q2());
      }
      i3v(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.g4i_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().m4i('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.p4i_1 - head.o4i_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.i4i_1 = subtract(this.i4i_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.o4i_1 = head.o4i_1 + toSkip | 0;
          if (head.o4i_1 === head.p4i_1) {
            this.u4i();
          }
        }
      }
      f4j(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.g4i_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.g4j(sink, startIndex, startIndex + toCopy | 0);
        this.i4i_1 = subtract(this.i4i_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.u4i();
        }
        return toCopy;
      }
      h4j(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.i4j(this, bytesWritten);
        return bytesWritten;
      }
      j4j(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.i4j(this, this.q2());
          throw EOFException().m4i('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.i4j(this, byteCount);
      }
      k4j(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.i4j(this, byteCount);
        }
        return byteCount;
      }
      t40() {
        return buffered(new (PeekSource())(this));
      }
      l4j(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.h4i_1 == null) {
          var result = SegmentPool_instance.l3w();
          this.g4i_1 = result;
          this.h4i_1 = result;
          return result;
        }
        var t = ensureNotNull(this.h4i_1);
        if ((t.p4i_1 + minimumCapacity | 0) > 8192 || !t.r4i_1) {
          var newTail = t.b4j(SegmentPool_instance.l3w());
          this.h4i_1 = newTail;
          return newTail;
        }
        return t;
      }
      o4j(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.l4j(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.p4j();
          var toCopy = Math.min(tmp0, b);
          tail.q4j(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.i4i_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.i4i_1 = add(tmp0_0, fromInt(other));
      }
      s4j(source, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var read = source.h4j(this, remainingByteCount);
          if (read === -1n) {
            throw EOFException().m4i('Source exhausted before reading ' + byteCount.toString() + ' bytes. ' + ('Only ' + subtract(byteCount, remainingByteCount).toString() + ' were read.'));
          }
          remainingByteCount = subtract(remainingByteCount, read);
        }
      }
      i4j(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().o2(toString(message));
        }
        checkOffsetAndCount(source.i4i_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.g4i_1).q2())) {
            var tail = this.h4i_1;
            var tmp;
            if (!(tail == null) && tail.r4i_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.p4i_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.t4j() ? 0 : tail.o4i_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.g4i_1).v4j(tail, convertToInt(remainingByteCount));
              source.i4i_1 = subtract(source.i4i_1, remainingByteCount);
              this.i4i_1 = add(this.i4i_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.g4i_1 = ensureNotNull(source.g4i_1).u4j(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.g4i_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.g4i_1 = segmentToMove.w4j();
          if (source.g4i_1 == null) {
            source.h4i_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.g4i_1 == null) {
            this.g4i_1 = segmentToMove;
            this.h4i_1 = segmentToMove;
          } else if (true) {
            this.h4i_1 = ensureNotNull(this.h4i_1).b4j(segmentToMove).c4j();
            if (ensureNotNull(this.h4i_1).t4i_1 == null) {
              this.g4i_1 = this.h4i_1;
            }
          } else {
            this.h4i_1 = ensureNotNull(this.h4i_1).b4j(segmentToMove);
          }
          source.i4i_1 = subtract(source.i4i_1, movedByteCount);
          this.i4i_1 = add(this.i4i_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      x4j(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.h4j(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      y4j(byte) {
        this.l4j(1).z4j(byte);
        this.i4i_1 = add(this.i4i_1, 1n);
      }
      a4k(short) {
        this.l4j(2).b4k(short);
        this.i4i_1 = add(this.i4i_1, 2n);
      }
      m6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().vb(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.g4i_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.c4k(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.s4i_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      u4i() {
        var oldHead = ensureNotNull(this.g4i_1);
        var nextHead = oldHead.s4i_1;
        this.g4i_1 = nextHead;
        if (nextHead == null) {
          this.h4i_1 = null;
        } else {
          nextHead.t4i_1 = null;
        }
        oldHead.s4i_1 = null;
        SegmentPool_instance.d4k(oldHead);
      }
      e4k() {
        var oldTail = ensureNotNull(this.h4i_1);
        var newTail = oldTail.t4i_1;
        this.h4i_1 = newTail;
        if (newTail == null) {
          this.g4i_1 = null;
        } else {
          newTail.s4i_1 = null;
        }
        oldTail.t4i_1 = null;
        SegmentPool_instance.d4k(oldTail);
      }
    }
    protoOf($).r4j = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
